import { BasePage } from '@/components/ui/base-page'

export function MGTPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add MGTPage specific content here */}
    </BasePage>
  )
}